export const CARD = 'CARD'
export const OPEN_BANKING = 'OPEN_BANKING';

export default CARD;
